module.exports = __webpack_public_path__ + "img/subChangeGoodBadType.4a8ba3eb.png";